import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { TransactionEnumClient } from '@frontend/transaction/api';
import { TransactionTrigger, TransactionTriggerName } from '@frontend/transaction/types';
import { fetchGeneralWorkflowTriggers, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { TransactionTriggerSelectProps } from './transaction-trigger-select.component';

interface ViewProps {
    options: SelectOption<TransactionTriggerName>[];
}

const useTransactionTriggerSelect = (props: TransactionTriggerSelectProps): ViewProps => {
    const [triggers, changeTriggers] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowTriggers());
        TransactionEnumClient.fetchTransactionTriggers().then(changeTriggers);
    }, []);

    const options = useMemo(() => {
        if (!triggers || !workflowSharedState.generalWorkflowTriggers) return [];
        return [...triggers, ...workflowSharedState.generalWorkflowTriggers].map((transactionTrigger) => {
            const found = TransactionTrigger.ALL.find((t) => t.value === transactionTrigger);
            if (found) return { value: found.value, label: found.value, display: found.displayName };
            else
                return {
                    value: transactionTrigger,
                    label: transactionTrigger.replace(/_/g, ' ')
                };
        });
    }, [triggers, workflowSharedState.generalWorkflowTriggers]);

    return { options };
};

export default useTransactionTriggerSelect;
